/**
 * `@eis/claimservice-sdk` — the generated client for claimservice's REST API (SDD-018 §8, §9).
 *
 * `./generated` comes from api/openapi/vendor/claimservice_openapi_spec.json — the document the
 * pinned claimservice image serves (`/claimservice/api-json`), vendored verbatim with provenance
 * (api/openapi/vendor/CLAIMSERVICE.md) — via `pnpm gen:sdk`; never hand-edited, diffed by
 * `make gen-check` (rule 26). The types are re-exported wholesale under one namespace, so a call site
 * says `ClaimApi.ClaimClass` and never re-declares a shape another team owns.
 *
 * Built with `createForeignClient`, deliberately NOT `createEisClient`, for the Partner service's
 * reason (`@eis/partnerservice-sdk`): claimservice is not party to the platform's ETag/If-Match
 * contract (T-12), so the concurrency middleware would only misreport its plain 409s. Bearer auth,
 * traceparent (T-13) and the session refresh (SDD-019) come from the shared runtime.
 */
import type { Client } from 'openapi-fetch';
import { createForeignClient, type ForeignClientOptions } from '@eis/sdk-runtime';
import type { paths } from './generated/claimservice.v1';

export type * as ClaimApi from './generated/claimservice.v1';
export type { TokenProvider, TraceparentProvider } from '@eis/sdk-runtime';
export {
  createSessionRefreshMiddleware,
  isSafeToReplay,
  type SessionRefreshOptions,
} from '@eis/sdk-runtime';

/**
 * `baseUrl` is the ORIGIN the service's paths are mounted under — `/api` behind the console's
 * reverse proxy, never `/api/<service>`: the generated paths already carry the service's own
 * prefix, and Caddy strips only `/api`.
 */
export type ClaimServiceClientOptions = ForeignClientOptions;

export type ClaimServiceClient = Client<paths>;

export function createClaimServiceClient(options: ClaimServiceClientOptions): ClaimServiceClient {
  return createForeignClient<paths>(options);
}
